// src/pages/ForgotPasswordPage/ForgotPasswordPage.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function ForgotPasswordPage({ enterpriseId }) {
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  // Простейшая проверка email
  const isEmailValid = (value) => {
    const emailRegex = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(value.trim());
  };

  // Активна ли кнопка «Отправить»
  const canSubmit = () => {
    return isEmailValid(email);
  };

  // Мок-функция отправки «запроса на сервер»
  // Имитация, что email "existing@test.com" существует, все остальные — нет
  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!isEmailValid(email)) {
      setErrorMsg("Некорректный формат email");
      return;
    }

    // «Отправляем» на сервер
    if (email.toLowerCase() === "existing@test.com") {
      // Допустим, если email «найден»
      setSuccessMsg("Инструкции по восстановлению пароля отправлены вам на почту.");

      // Сразу переходим на страницу сброса пароля (имитируя клик из письма)
      navigate(`/${enterpriseId}/reset-password?token=valid`);
    } else {
      // Если email «не существует»
      setErrorMsg("Учетная запись с таким email не найдена");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f0f0",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#fff",
          padding: "2rem",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          width: "350px",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          Восстановление пароля
        </h2>

        {/* Поле для ввода email */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label htmlFor="email">Введите ваш email:</label>
          <input
            type="email"
            id="email"
            placeholder="mail@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
          />
        </div>

        {/* Ошибка, если есть */}
        {errorMsg && (
          <div
            style={{
              color: "red",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {errorMsg}
          </div>
        )}

        {/* Успех, если есть */}
        {successMsg && (
          <div
            style={{
              color: "green",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {successMsg}
          </div>
        )}

        {/* Кнопка «Отправить» */}
        <button
          type="submit"
          disabled={!canSubmit()}
          style={{
            width: "100%",
            padding: "0.5rem",
            backgroundColor: canSubmit() ? "#007bff" : "#cccccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: canSubmit() ? "pointer" : "not-allowed",
          }}
        >
          Отправить
        </button>
      </form>
    </div>
  );
}

export default ForgotPasswordPage;
